export const styles = {
    list: {
        paddingLeft: 20
    }
};
